// import { Component, OnInit } from '@angular/core';
import {
  AfterViewInit, Component, ElementRef, forwardRef, Input, NgZone, OnDestroy,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare let tinymce: any;

export const TINYMCE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TinyeditorComponent),
  multi: true
};

@Component({
  selector: 'app-tinyeditor',
  templateUrl: './tinyeditor.component.html',
  styleUrls: ['./tinyeditor.component.css'],
  providers: [TINYMCE_VALUE_ACCESSOR]

})
export class TinyeditorComponent {
  config: any = {
    height: 250,
    theme: 'modern',
    browser_spellcheck: true,
    plugins: 'directionality visualblocks visualchars fullscreen  imagetools media template codesample  charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists textcolor wordcount contextmenu textpattern',
    toolbar: 'undo redo | formatselect | bold italic underline fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat',
    fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
    font_formats:
    "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Arial Narrow=arial narrow, Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Verdana=verdana,geneva; Wingdings=wingdings,zapf dingbats",
    menubar:false,
    // setup : function(ed) {
    //   ed.on('init', function(ed) {
    //    ed.target.editorCommands.execCommand("fontName", false, "arial narrow");
    //    ed.target.editorCommands.execCommand("fontSize", false, "12pt");
    //   });
    //  },
    content_style: ".mce-content-body {font-size:12pt;font-family:arial narrow;}",
    templates: [
    { title: 'Test template 1', content: 'Test 1' },
    { title: 'Test template 2', content: 'Test 2' }
    ],
    
    content_css: [
      '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
      '//www.tinymce.com/css/codepen.min.css'
    ]
    };
}